<script lang="ts">
	import { onMount } from 'svelte';
	import { Config } from '#lib/constants/config.js';
	import { page } from '$app/state';

	let newsletter = $derived(page.data.newsletter);

	onMount(() => {
		const link = `${Config.Domain}/news/newsletter/${newsletter?.slug}`;

		const bodyIntro =
			"Get the HENI News Daily Art Digest delivered to your inbox. HENI News brings you curated coverage of the art world's most important stories and developments.";
		const emailBody = `${bodyIntro}%0D%0A%0D%0A${link}`;

		window.location.replace(`sms:?body=${emailBody}`);
	});
</script>

<div class="fixed z-10 h-[100vh] w-[100vw] bg-white"></div>
